window.siteKey = document.querySelector('script[data-recaptcha-sitekey]').getAttribute('data-recaptcha-sitekey');

// How this code snippet works:
// This logic overwrites the default behavior of `grecaptcha.ready()` to
// ensure that it can be safely called at any time. When `grecaptcha.ready()`
// is called before reCAPTCHA is loaded, the callback function that is passed
// by `grecaptcha.ready()` is enqueued for execution after reCAPTCHA is
// loaded.
if (typeof grecaptcha === 'undefined') {
  grecaptcha = {};
}
grecaptcha.ready = function (cb) {
  if (typeof grecaptcha === 'undefined') {
    // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
    // configuration. By default, any functions listed in its 'fns' property
    // are automatically executed when reCAPTCHA loads.
    const c = '___grecaptcha_cfg';
    window[c] = window[c] || {};
    (window[c]['fns'] = window[c]['fns'] || []).push(cb);
  } else {
    cb();
  }
};
const forms = document.querySelectorAll('form.recaptcha');
forms.forEach(form => form.addEventListener('submit', e => recaptchaSubmit(e, form)));
function recaptchaSubmit(e, form) {
  e.preventDefault();
  const gRecaptchaResponse = document.createElement('input');
  gRecaptchaResponse.type = 'hidden';
  gRecaptchaResponse.name = 'g-recaptcha-response';
  grecaptcha.ready(() => {
    grecaptcha.execute(window.siteKey, {
      action: 'submit'
    }).then(token => {
      gRecaptchaResponse.value = token;
      form.appendChild(gRecaptchaResponse);
      form.submit();
    });
  });
}